<template>
  <div :class="[$style.container, $style[theme]]">
    <div :class="$style.textMessage">
      <span v-html="messageText" ref="text"></span>
      <span v-if="message.content.new_body" @click.stop="toggleOriginal" :class="$style.showOriginal">
        (<template v-if="showOriginal">{{ $t('translation.showTranslated') }}</template>
        <template v-else>{{ $t('translation.showOriginal') }}</template
        >)
      </span>
    </div>
  </div>
</template>

<script>
import linkifyUrls from 'linkify-urls'
import { mapGetters, mapMutations } from 'vuex'
// eslint-disable-next-line no-unused-vars
import { formattedUserName } from '@/helpers'

const REG_FIRST_MENTION = /^(@)([^\s]+)/
const REG_OTHER_MENTIONS = /([\s+])(@)([^\s]+)/g
const REG_MATRIX_USER_ID = />@\w+:matrix\.sayhola\.io</gm

export default {
  name: 'message-content-text-matrix',
  props: {
    message: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showOriginal: false
    }
  },
  watch: {
    messageText: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          this.setEvents()
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      chatById: 'entities/chats/getById',
      members: 'matrix/roomMembers'
    }),
    messageText () {
      if (!this.message) return
      let { linkify, content } = this.formattedMessage
      if (linkify) {
        content = this.escape(content)
        content = this.linkify(content)
        content = this.mentionize(content)
      }
      if (this.showOriginal) return content

      const result = content.match(REG_MATRIX_USER_ID)
      if (result === null) return content

      const userId = result[0].slice(1, -1)
      const user = this.members.find(member => member.id === userId)
      if (result == null) return content

      const display_name = formattedUserName(user.display_name)
      return content.replaceAll(result[0], `>${display_name}<`)
    },
    mentions () {
      if (!this.message.payload) return
      const txt = this.message.payload
      const pattern = /\B@[^\s]+/gi
      return txt.match(pattern).map(mention => mention.slice(1))
    },
    mentionedUsers () {
      const chat = this.chatById(this.message.chatId)
      const participants = chat.participantsUsers
      return participants.filter(user => this.mentions.includes(user.nickname))
    },
    formattedMessage () {
      if (this.message.content.new_body && !this.showOriginal) {
        return { linkify: true, content: this.message.content.new_body }
      }
      if (this.message.content.formatted_body && this.message.content['m.relates_to']) {
        return { linkify: false, content: this.message.content.formatted_body.split('</mx-reply>')[1] }
      }
      if (this.message.content.formatted_body) {
        // return formattedUserName(this.message.content.body)
        return { linkify: false, content: this.message.content.formatted_body }
      }
      return { linkify: true, content: this.message.content.body }
    }
  },
  methods: {
    ...mapMutations({
      removeTranslation: 'matrix/REMOVE_TRANSLATE_MESSAGE'
    }),
    escape (text) {
      if (this.message.content.formatted_body) {
        return text
      } else {
        return text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      }
    },
    linkify (text) {
      if (this.message.content.formatted_body) {
        return text
      } else {
        return linkifyUrls(text, {
          attributes: {
            target: '_blank',
            rel: 'noopener noreferrer',
            onclick: 'event.stopPropagation()'
          }
        })
      }
    },
    mentionize (text) {
      if (this.message.content.formatted_body) {
        return text
      } else {
        const onclick = `event.stopPropagation();`
        text = text.replace(REG_FIRST_MENTION, `<span data-nickname="$2" class="link" onclick="${onclick}">$1$2</span>`)
        return text.replace(
          REG_OTHER_MENTIONS,
          `$1<span data-nickname="$3" class="link" onclick="${onclick}">$2$3</span>`
        )
      }
    },
    setEvents () {
      if (!this.$refs.text) return
      const nodeList = this.$refs.text.querySelectorAll('.link')
      nodeList.forEach(node => {
        node.addEventListener('click', () => {
          this.showProfile(node.dataset.nickname)
        })
      })
    },
    showProfile (nickname) {
      const user = this.mentionedUsers.find(user => user.nickname === nickname)
      if (!user) return
      this.$modal.show('profile', {
        userId: user.userId,
        chatId: this.message.chatId
      })
    },
    toggleOriginal () {
      this.showOriginal = !this.showOriginal
      this.$emit('show-translate', this.showOriginal)
    }
  }
}
</script>

<style module lang="scss">
.container {
  font-size: 14px;
}
.textMessage {
  a {
    font-weight: 500;
    color: $text-colored;
  }
  blockquote {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  span {
    &:first-child {
      white-space: pre-wrap;
    }
  }
}

.showOriginal {
  white-space: nowrap;
  margin-top: 3px;
  margin-left: 2px;
  font-size: 10px;
  color: $text-colored;
  &:hover {
    text-decoration: underline;
  }
}
.green {
  .showOriginal {
    color: $white;
  }
  .textMessage {
    a {
      color: $white;
    }
  }
}
</style>
